/**
 * Script de Visibilidade Ultra-Fluido
 * Isolado das funções nativas do tema para evitar micro-stutters
 */
(function() {
  const initCustomBannerReveal = () => {
    const items = document.querySelectorAll('.m-custom-reveal-item:not(.is-active)');
    
    if (!items.length) return;

    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = entry.target;

          // Sincroniza com o refresh do monitor (60fps/120fps)
          window.requestAnimationFrame(() => {
            // Pequeno delay para garantir que o browser já decodificou a imagem
            setTimeout(() => {
               target.classList.add('is-active');
            }, 50);
          });
          
          revealObserver.unobserve(target);
        }
      });
    }, {
      rootMargin: '0px 0px -5% 0px',
      threshold: 0.01
    });

    items.forEach(item => revealObserver.observe(item));
  };

  // Correção para carregamento rápido e navegação entre páginas
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomBannerReveal);
  } else {
    initCustomBannerReveal();
  }

  // Escuta eventos de troca de secção no editor da Shopify
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.contains(document.querySelector('.m-custom-reveal-item'))) {
      initCustomBannerReveal();
    }
  });
})();